module.exports = __webpack_public_path__ + "img/article8.cdbf5be0.jpg";